"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmbClientOrderServiceMode = exports.SmbBookingType = void 0;
var SmbBookingType;
(function (SmbBookingType) {
    SmbBookingType["INVALID"] = "INVALID";
    SmbBookingType["FREIGHT_ONLY"] = "FREIGHT_ONLY";
    SmbBookingType["FULFILLMENT_BY_FLEXPORT"] = "FULFILLMENT_BY_FLEXPORT";
    SmbBookingType["FULFILLMENT_BY_FLEXPORT_AND_AMAZON"] = "FULFILLMENT_BY_FLEXPORT_AND_AMAZON";
    SmbBookingType["FBA_PREP_SINGLE_LOCATION"] = "FBA_PREP_SINGLE_LOCATION";
    SmbBookingType["FBA_PREP_MULTIPLE_LOCATIONS"] = "FBA_PREP_MULTIPLE_LOCATIONS";
    SmbBookingType["FBA_PREP_UNKNOWN_LOCATIONS"] = "FBA_PREP_UNKNOWN_LOCATIONS";
    SmbBookingType["FBA_SINGLE_LOCATION"] = "FBA_SINGLE_LOCATION";
    SmbBookingType["FBA_MULTIPLE_LOCATIONS"] = "FBA_MULTIPLE_LOCATIONS";
    SmbBookingType["FBA_UNKNOWN_LOCATIONS"] = "FBA_UNKNOWN_LOCATIONS";
})(SmbBookingType = exports.SmbBookingType || (exports.SmbBookingType = {}));
var SmbClientOrderServiceMode;
(function (SmbClientOrderServiceMode) {
    SmbClientOrderServiceMode["INVALID"] = "INVALID";
    SmbClientOrderServiceMode["OCEAN_FCL"] = "OCEAN_FCL";
    SmbClientOrderServiceMode["OCEAN_LCL"] = "OCEAN_LCL";
    SmbClientOrderServiceMode["AIR"] = "AIR";
    SmbClientOrderServiceMode["CUSTOMS"] = "CUSTOMS";
})(SmbClientOrderServiceMode = exports.SmbClientOrderServiceMode || (exports.SmbClientOrderServiceMode = {}));
//# sourceMappingURL=SMBUpsert.js.map